import { Events, NavController } from 'ionic-angular';
import { UserData } from '../providers/user-data';
import { AppSettings } from '../config/app-settings';
// import { EventCodes } from '../core/codes';
import { Observable } from 'rxjs/Observable';
import { PageRef } from '../core/page-ref';
import 'rxjs/add/operator/toPromise';
import { StoreLocatorData } from '../modules/store-locator/providers/store-locator-data';
export class PageBaseFull {
	public currentUser: any;
	public currentStore: any;
	public pageRef: PageRef;
	public storeLocatorData : StoreLocatorData;
	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
	){
		if(!this.pageRef){
			var injector =(<any>window).applicationInjector;
			if(injector){
				this.pageRef = injector.get(PageRef);
			}
		}
		if(!this.storeLocatorData){
			var injector =(<any>window).applicationInjector;
			if(injector){
				this.storeLocatorData = injector.get(StoreLocatorData);
			}
		}
		console.log('contructor');
		// var fn = (nav)=>{
		// 	console.log('full-bottom');
		// 	if(nav.name !== 'full-bottom'){
		// 		return;
		// 	}
			
		// 	console.log("Navigation Loaded: ", nav.name);	
			
		// 	let footerSection = (<any>document.getElementById('footerSection'));
		// 	// console.log(footerSection);

		// 	let ionContent = document.getElementsByTagName('ion-content');
		// 	if(footerSection && ionContent && ionContent[0]){
		// 		let scrollContent = ionContent[0].getElementsByClassName('scroll-content');
		// 		let footerElements = footerSection.children.length;
		// 		for(let i=0; i < footerElements; i++){
		// 			scrollContent[0].appendChild(footerSection.children[0]);	
		// 		}
		// 	}
				
			
			
			
			
		// 	//this.events.unsubscribe(EventCodes.NAVIGATION_LOADED, fn);
		// };
		// this.events.subscribe(EventCodes.NAVIGATION_LOADED, fn);	

		setTimeout(()=>{
			console.log("Custom script to Load when page loaded");
			this.appendFooterScripts('assets-full/base/js/page-loaded.js');	
		}, 1000);
	}	
	
	public loadCurrentStore(){
		return Observable.create((observer) => {
			this.storeLocatorData.getCurrentStore().subscribe((store) => {
		       this.currentStore = store;
				observer.next(store);
				observer.complete();
			});	
		});
	}

	public loadCurrentUser(){
		return Observable.create((observer) => {
			this.userData.hasLoggedIn().subscribe((isLoggedIn) => {
		        if(isLoggedIn){
		        	this.userData.getUser().subscribe((user) => {
						this.currentUser = user;
						observer.next(user);
						observer.complete();
					});
		        }else{
			        observer.next(null);
			        observer.complete();
			    }
			});	
		});
	}

	public goToPage(name){
		this.nav.push(this.pageRef.get(name));
	}
	
	public appendHeader(link) {
		console.log('Inject Styles');

		let head = document.head;

		if(link){
			head.appendChild(this.headLink(link));
		}

        // console.log(head);
	}

	public appendFooterScripts(script){
		console.log('Inject Footer Scripts');

		let body = document.body;

		if(script){
			body.appendChild(this.footerScript(script));
		}
		
		// console.log(body);
	}

	private headLink(href){
		let link = document.createElement('link');
	    link.rel = 'stylesheet';
	    link.type = 'text/css';
	    link.href = href;

	    return link;
	}

	private footerScript(src){
		let link = document.createElement('script');
	    link.type = 'text/javascript';
	    link.src = src;

	    return link;
	}
	
	// public ionViewCanEnter():Promise<boolean>{
	// 	console.log('ionViewCanEnter');
	// 	if(this.settings.isLoaded){
	// 		return Observable.from([this.loadCurrentUser(),this.loadCurrentStore()]).combineAll().toPromise().then((user)=>{
	// 			if(this.settings && this.settings.requireLogin && !user){
	// 				this.nav.setRoot(this.pageRef.get('login')); 
	// 				return false;    
	// 			}
	// 			else{
	// 				return true;
	// 			}
	// 		});
	// 	}
	// 	else{
	// 		var src:Promise<any> =  this.settings.getData().take(1).toPromise();
	// 		return src.then((settings)=>{
	// 			return Observable.from([this.loadCurrentUser(),this.loadCurrentStore()]).combineAll().toPromise().then((user)=>{
	// 				if(this.settings && this.settings.requireLogin && !user){
	// 					this.nav.setRoot(this.pageRef.get('login')); 
	// 					return false;   
	// 				}
	// 				else{
	// 					return true;
	// 				}
	// 			});

	// 		});	
	// 	}
	// }
}


// WEBPACK FOOTER //
// ./src/core/page-base.full.ts